import React, { useState } from 'react';
import { Container, Paper, Tabs, Tab, Box, Typography } from '@mui/material';
import Layout from '../components/Layout';
import SMSTours from '../components/SMSTours';
import SMSLogs from '../components/SMSLogs';

const SMS = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Layout>
      <Container maxWidth={false} sx={{ width: '100%' }}>
        <Typography variant="h4" gutterBottom fontWeight={700} sx={{ mb: 2 }}>
          SMS
        </Typography>
        <Paper sx={{ p: 3 }}>
          <Tabs value={tabValue} onChange={handleTabChange} sx={{ mb: 3 }}>
            <Tab label="Tours" />
            <Tab label="SMS Logs" />
          </Tabs>
          <Box>
            {tabValue === 0 && <SMSTours />}
            {tabValue === 1 && <SMSLogs />}
          </Box>
        </Paper>
      </Container>
    </Layout>
  );
};

export default SMS;



